import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const Root = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
}));
